// components/superAdmin/theme.js
// Small shared palette for the super-admin panel so every section looks the same.
export const SA = {
  font: 'Cairo, Tajawal, sans-serif',
  bg: '#F6F7FB',
  ink: '#14122B',
  text: '#1E1B4B',
  muted: '#6B7280',
  border: '#E6E8F0',
  primary: '#4338CA',
  primaryLight: '#A5B4FC',
  primarySoft: '#EEF0FF',
  success: '#059669',
  successSoft: '#ECFDF5',
  danger: '#DC2626',
  dangerSoft: '#FEF2F2',
  warnBg: '#FFF7E6',
  warnInk: '#B45309',
  warnBorder: '#FDE3B0',
};

export const cardSx = {
  bgcolor: '#fff',
  border: `1px solid ${SA.border}`,
  borderRadius: 3,
  boxShadow: 'none',
};
